import './style.scss';

export default function Header () {
  return (
    <header className="header">
      <h1 className="header__title">Pokedex</h1>
      <h3 className="header__subtitle">
        Sua mini enciclopédia online sobre pokémon
      </h3>
    </header>
  );
}